import React from "react";
import {
  Label,
  Button,
  DefaultButton,
  Modal,
  IconButton,
  initializeIcons,
} from "office-ui-fabric-react";
import { Grid, Row, Col } from "react-flexbox-grid";
import Common from "./Common";
import axios from "axios";
import Iframe from "react-iframe";
import logoPagoEfectivo from "../images/logopagoefectivo.png";
import logoVisa from "../images/logovisa.png";
function queryParameters(query) {
  var keyValuePairs = query.split(/[&?]/g);
  var params = {};
  for (var i = 0, n = keyValuePairs.length; i < n; ++i) {
    var m = keyValuePairs[i].match(/^([^=]+)(?:=([\s\S]*))?/);
    if (m) {
      var key = decodeURIComponent(m[1]);
      (params[key] || (params[key] = [])).push(decodeURIComponent(m[2]));
    }
  }
  return params;
}
initializeIcons(undefined, { disableWarnings: true });
class DetallePago extends React.Component {
  state = {
    invoice: "",
    total: "",
    dinvoice: "",
    dcodigo: "",
    urlCIP: "",
    tokenFinanzas: "abcABC123",
    loading: false,
    modal: false,
    mostrarCIP: false,
    CIPObtenido: "",
    enablePE: true,
  };
  componentDidMount() {
    const parametros = this.retrieveQueryParams();
    if (!parametros.ms) {
      this.setState(
        {
          invoice: atob(parametros.opi[0]),
          jwt: parametros.tk[0],
          tv: parametros.tv[0],
          loading: true,
        },
        async () => {
          // const resDecrypt = await axios.post(
          //   `${Common.urlAPI}/api/Pagos/DesEncriptarInformacion`,
          //   {
          //     invoice: this.state.invoice,
          //     codigo: this.state.jwt
          //   }
          // );
          // this.setState({
          //   dinvoice:resDecrypt.data.edo,
          //   dcodigo:resDecrypt.data.edc
          // }, async ()=>{
          let authPayment = {
            headers: {
              Authorization: "Bearer " + this.state.jwt,
            },
          };
          const resValidadoVisa = await axios
            .get(
              `${Common.urlAPI}/ValidarVisa/${this.state.invoice}`,
              authPayment
            )
            .catch((error) => {
              if (error.response.status === 401) {
                alert("El token es invalido para este usuario");
              }
            });
          if (resValidadoVisa.data.state === "OK") {
          } else {
            alert(
              "No se pudo validar por Visa, vuelva a intentarlo nuevamente"
            );
          }
          const resPaymentGet = await axios
            .get(`${Common.urlAPI}/payment/${this.state.invoice}`, authPayment)
            .catch((error) => {
              if (error.response.status === 401) {
                alert("El token es invalido para este usuario");
              }
            });

          if (resPaymentGet.data.Status === "NOK") {
            alert(resPaymentGet.data.message);
          } else if (resPaymentGet.data.detail.estado === "E") {
            const resNuevaOrden = await axios
              .get(
                `${Common.urlAPI}/GenerarPension/${resPaymentGet.data.detail.studentCode}/${this.state.invoice}`,
                authPayment
              )
              .catch((error) => {
                if (error.response.status === 401) {
                  alert("El token es invalido para este usuario");
                }
              });
            if (resNuevaOrden.data.state === "NOK") {
              alert(
                "La orden de pago ha sido pagada y se encuentra validando en el sistema."
              );
            } else {
              window.location = resNuevaOrden.data.url;
              console.log(resNuevaOrden.data.url);
            }
          } else if (resPaymentGet.data.detail.estado === "P") {
            this.setState({
              studentName: resPaymentGet.data.detail.studentName,
              arrears: resPaymentGet.data.detail.arrears,
              subtotal: resPaymentGet.data.detail.subtotal,
              total: parseFloat(
                resPaymentGet.data.detail.total.replace(",", ".")
              ).toFixed(2),
              studentCode: resPaymentGet.data.detail.studentCode,
            });
            var ip = require("ip");

            let data = {
              amount: this.state.total,
              antifraud: {
                clientIp: ip.address(),
                merchantDefineData: {
                  // MDD4: "estudiante@upn.pe",
                  MDD30: resPaymentGet.data.detail.studentCode.replace("N", ""),
                  MDD32: resPaymentGet.data.detail.studentCode,
                  MDD63: "DNI",
                  MDD65: resPaymentGet.data.detail.studentCode.replace("N", ""),
                  MDD75: "Registrado",
                  MDD77: resPaymentGet.data.detail.dias,
                },
              },
              channel: "web",
              recurrenceMaxAmount: null,
            };
            let auth = {
              headers: {
                Authorization: this.state.tv,
              },
            };
            const resSession = await axios
              .post(
                `${Common.urlAPISession}${this.props.idComercio}`,
                data,
                auth
              )
              .catch((error) => {
                if (
                  error.response.status === 400 &&
                  error.response.data.errorMessage ===
                    "Token has been used before"
                ) {
                  alert(
                    "El token ha sido usado por favor vuelva a generar uno accediendo desde su portal de pagos."
                  );
                } else if (error.response.status === 400) {
                  alert(error.response.data.errorMessage);
                }
              });
            //Generar Boton
            let form = document.createElement("form");
            form.setAttribute("method", "post");
            form.setAttribute(
              "action",
              `${Common.urlAPI}/ValidarPagoVisa/${this.state.total}/${this.state.invoice}?tk=${this.state.tv}&p=${this.state.invoice}&j=${this.state.jwt}`
            );
            form.setAttribute("id", "boton_pago");
            document.getElementById("btn_pago").appendChild(form);
            let scriptEl = document.createElement("script");

            scriptEl.setAttribute("src", Common.urlFormulario);
            scriptEl.setAttribute(
              "data-sessiontoken",
              resSession.data.sessionKey
            );
            scriptEl.setAttribute("data-merchantid", this.props.idComercio);
            scriptEl.setAttribute(
              "data-merchantlogo",
              "https://www.laureate.net/wp-content/uploads/2019/03/UPN.png"
            );
            scriptEl.setAttribute(
              "data-merchantname",
              "Universidad Privada del Norte"
            );
            scriptEl.setAttribute("data-purchasenumber", this.state.invoice);
            scriptEl.setAttribute("data-channel", "web");
            scriptEl.setAttribute("data-amount", this.state.total);
            scriptEl.setAttribute("dataexpirationminutes", 3);
            scriptEl.setAttribute("data-cardholderlastname", "");
            scriptEl.setAttribute("data-cardholderemail", "");
            scriptEl.setAttribute(
              "data-timeouturl",
              "http://localhost/errortiemout"
            );
            document.getElementById("boton_pago").appendChild(scriptEl);
            this.setState({
              loading: false,
            });
          } else if (resPaymentGet.data.detail.estado === "C") {
            alert("Esta Orden de pago ya fue pagada.");
          } else if (resPaymentGet.data.detail.estado === "E") {
            alert("Esta Orden de pago fue eliminada");
          }
        }
      );
    } else {
      if (parametros.ms[0].replace("'", "").replace("'", "") === "") {
        this.props.handleConfirmar(
          parametros.od[0],
          parametros.ms[0],
          parametros.t[0],
          parametros.j[0]
        );
      } else {
        this.props.handleValidar(
          parametros.od[0],
          parametros.ms[0],
          parametros.t[0],
          parametros.j[0],
          parametros.tp[0],
          parametros.tj[0]
        );
      }
    }
  }
  retrieveQueryParams = () => {
    const queryParams = window.location.search.slice(1);

    if (queryParams) {
      const objetoQueryParameters = queryParameters(queryParams);
      return objetoQueryParameters;
    } else {
      // console.log("No existen query parameters en la url");
      return "";
    }
  };
  handlePagoEfectivo = () => {
    this.setState(
      {
        enablePE: false,
      },
      async () => {
        let authPayment = {
          headers: {
            Authorization: "Bearer " + this.state.jwt,
          },
        };
        const resCIPExistente = await axios.get(
          `${Common.urlAPI}/VerificarExistenciaCIP/${this.state.invoice}`,
          authPayment
        );
        if (
          resCIPExistente.data.cip.length < 1 &&
          this.state.urlCIP.length === 0
        ) {
          if (this.state.urlCIP.length < 1) {
            const resPagoEfectivo = await axios
              .get(
                `${Common.urlAPI}/ObtenerPagoEfectivo/${this.state.invoice}/${this.state.studentCode}`,
                authPayment
              )
              .catch((error) => {
                if (error.response.status === 401) {
                  alert("El token es invalido para este usuario");
                }
              });
            if (resPagoEfectivo.data.state === "OK") {
              // window.location = resPagoEfectivo.data.message;
              this.setState({
                urlCIP: resPagoEfectivo.data.message,
                modal: true,
                enablePE: true,
              });
            }
          }
        } else if (this.state.urlCIP.length !== 0) {
          this.setState({
            modal: true,
            enablePE: true,
            mostrarCIP: false,
          });
        } else {
          this.setState({
            CIPObtenido: resCIPExistente.data.cip,
            fechaObtenida: resCIPExistente.data.fechaVencimiento,
            mostrarCIP: true,
            enablePE: true,
          });
        }
      }
    );
  };
  closeModal = () => {
    this.setState({
      modal: false,
    });
  };
  render() {
    var style = {
      backgroundColor: "#F8F8F8",
      borderTop: "1px solid #E7E7E7",
      textAlign: "center",
      padding: "20px",
      position: "fixed",
      left: "0",
      bottom: "0",
      height: "60px",
      width: "100%",
    };

    var phantom = {
      display: "block",
      padding: "20px",
      height: "60px",
      width: "100%",
    };
    return (
      <React.Fragment>
        {this.state.loading ? <div className="preloader"></div> : null}
        <Grid style={{ padding: "2rem 5rem" }}>
          <Row middle="xs" className="card">
            <Col xs={12} sm={12} className="container">
              <Row>
                <Col xs={12} sm={3} style={{ paddingLeft: "19rem" }}>
                  <img
                    src="https://www.laureate.net/wp-content/uploads/2019/03/UPN.png"
                    height="80"
                    width="160"
                    alt="logo"
                  ></img>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={12}>
                  <Row center="xs">
                    <Col xs={12} sm={6}>
                      <h3 className="current">Información de pago</h3>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row center="xs">
                <Col xs={12} sm={3}>
                  <Label style={{ fontWeight: "bold" }}>Nro Orden Pago</Label>
                </Col>
                <Col xs={12} sm={3}>
                  <Label>{this.state.invoice}</Label>
                </Col>
              </Row>
              <Row center="xs">
                <Col xs={12} sm={3}>
                  <Label style={{ fontWeight: "bold" }}>
                    Código Estudiante
                  </Label>
                </Col>
                <Col xs={12} sm={3}>
                  <Label>{this.state.studentCode}</Label>
                </Col>
              </Row>
              <Row center="xs">
                <Col xs={12} sm={3}>
                  <Label style={{ fontWeight: "bold" }}>
                    Nombre Estudiante
                  </Label>
                </Col>
                <Col xs={12} sm={3}>
                  <Label>{this.state.studentName}</Label>
                </Col>
              </Row>
              <Row center="xs">
                <Col
                  xs={12}
                  sm={3}
                  style={{ borderTop: "solid", borderBottom: "solid" }}
                >
                  <Label style={{ fontWeight: "bold" }}>Total</Label>
                </Col>
                <Col
                  xs={12}
                  sm={3}
                  style={{ borderTop: "solid", borderBottom: "solid" }}
                >
                  <Label>S/{this.state.total}</Label>
                </Col>
              </Row>
              <br></br>
              <Row style={{ fontSize: "0.8rem", padding: "0rem 1rem" }}>
                <Col xs={12} sm={12} className="alert">
                  <label style={{ textAlign: "left !important" }}>
                    Al seleccionar PAGOEFECTIVO generarás un código CIP, con
                    este código podrás realizar el pago por el canal que desees.
                    Este código tiene una vigencia de 24 horas, al pasar este
                    tiempo se anulará.
                  </label>
                  <br></br>
                  <br></br>
                  <label style={{ textAlign: "left !important" }}>
                    ¿Cómo pagar con PagoEfectivo?
                  </label>
                  <br></br>
                  <br></br>
                  <label>
                    - Transaferencias bancarias vía PagoEfectivo - Paga en BBVA,
                    BCP, Interbank, Scotiabank, BanBif, Caja Arequipa, a través
                    de la banca por internet o banca móvil en la opción pago de
                    servicios.
                  </label>
                  <br></br>
                  <br></br>
                  <label style={{ textAlign: "left !important" }}>
                    Depósitos en efectivo vía PagoEfectivo - Paga en BBVA, BCP,
                    Interbank, Scotiabank, BanBif, Western Union, Tambo+,
                    Kasnet, Full Carga, Red Digital, Money Gram, Caja Arequipa,
                    Disashop, Banco de la Nación, Caja Sullana, Caja de los
                    Andes, Caja Paita, Caja Trujillo, Banco Azteca, Caja del
                    Santa, Caja Raíz.
                  </label>
                  {/* <ul>
                    <li>
                      Al seleccionar{" "}
                      <span style={{ fontWeight: "bold" }}>PagoEfectivo</span>{" "}
                      generarás un código CIP, con este código podrás realizar
                      el pago por el canal que desees. Este código tiene una
                      vigencia de 24 horas, al pasar este tiempo se anulará.
                    </li>
                    <li>
                      Lugar de recaudo:{" "}
                      <span style={{ fontWeight: "bold" }}>
                        Agentes y Bodegas
                      </span>{" "}
                      de: Tambo, Wester Union, Full Carga, KASNET, Money Gram,
                      Diashop y Red Digital( comisión de 1 sol).{" "}
                      <span style={{ fontWeight: "bold" }}>
                        . Banca por internet, Banca Móvil, Agencias y Agentes y
                        Bodegas
                      </span>{" "}
                      de: BCP/ Interbank/ Scotiabank/ Banbif/ Caja Arequipa.
                      <span style={{ fontWeight: "bold" }}>Agencias:</span>{" "}
                      Banco de la Nación/ Banco Azteca/ Caja del Santa/ Caja Los
                      Andes/ Caja Sullana/ Caja Paita y Raiz. Haga click{" "}
                      <a
                        style={{ color: "black", fontWeight: "bold" }}
                        href="https://pagoefectivo.pe/pe"
                        target="_blank"
                      >
                        aquí
                      </a>{" "}
                      para más información
                    </li>
                  </ul> */}
                </Col>
              </Row>
              <Row center="xs">
                <Col xs={12} sm={3}>
                  <DefaultButton
                    className="start-js-btn2 modal-opener default"
                    text="PagoEfectivo"
                    onClick={this.handlePagoEfectivo}
                    disabled={!this.state.enablePE}
                  ></DefaultButton>
                  <br></br>
                  <br></br>
                  <img
                    src="https://prod.cds.pagoefectivo.g3c.pe/img/general/pagoefectivo-logo.png?v=i7amcvxj6tk"
                    alt="LogoPagoEfectivo"
                    width="100%"
                  ></img>
                </Col>
                <Col xs={12} sm={3} style={{ borderLeft: "1px solid" }}>
                  <div id="btn_pago"></div>
                  <br></br>
                  <img
                    src="https://www.alejoscolor.com/wp-content/uploads/2020/05/formas-pago.png"
                    alt="LogoVisa"
                    width="100%"
                  ></img>
                </Col>
              </Row>
              <br></br>
              {this.state.mostrarCIP ? (
                <Row center="xs">
                  <Col xs={12} sm={5}>
                    <React.Fragment>
                      <h4>
                        Ya existe un CIP generado {this.state.CIPObtenido}
                      </h4>
                      <h4>Fecha Vencimiento: {this.state.fechaObtenida}</h4>
                    </React.Fragment>
                  </Col>
                </Row>
              ) : null}
              <Row center="xs">
                <Col xs={12} sm={8}>
                  <Modal isOpen={this.state.modal} onDismiss={this.closeModal}>
                    <Row>
                      <Col xs={12} sm={12}>
                        <IconButton
                          iconProps={{ iconName: "Cancel" }}
                          ariaLabel="Close popup modal"
                          onClick={this.closeModal}
                        />
                      </Col>
                    </Row>
                    <Row className="fila-iframe">
                      <Col xs={12} sm={12}>
                        <Iframe
                          url={this.state.urlCIP}
                          id="iCIP"
                          display="initial"
                          position="relative"
                          width="100%"
                          height="100%"
                        ></Iframe>
                      </Col>
                    </Row>
                    {/* <Label>OK</Label> */}
                  </Modal>
                </Col>
              </Row>
              <br></br>
              {/* <Row center="xs">
                <Col xs={12} sm={12}>
                  <DefaultButton
                    className="btn-primary"
                    text="Cancelar"
                    onClick={this.handleCancelar}
                  ></DefaultButton>
                </Col>
              </Row> */}
              <hr></hr>
              <br></br>
              <Row center="xs">
                <Col xs={12} sm={12}>
                  Universidad Privada del Norte - 2020
                </Col>
              </Row>
              <br></br>
            </Col>
          </Row>
          {/* <div style={phantom} />
          <div style={style}>Universidad Privada del Norte - 2020</div> */}
        </Grid>
      </React.Fragment>
    );
  }
}

export default DetallePago;
